import { AppError, ErrorCode } from "../shared/errors/app-error.js";
import type { TenantOwned } from "../shared/kernel/entity.js";
import type { ClientId } from "../shared/kernel/identifiers.js";

export function assertTenantOwnership(
  entity: TenantOwned,
  expectedClientId: ClientId
): void {
  if (entity.clientId !== expectedClientId) {
    throw new AppError(
      ErrorCode.Authorization,
      "Cross-tenant entity access was blocked",
      { safeMessage: "Access denied" }
    );
  }
}

export function getActiveClientId(context: { activeClientId?: string | null }): string {
  if (!context?.activeClientId) {
    throw new AppError(ErrorCode.Authorization, 'No active client in context');
  }
  return context.activeClientId;
}

